/*
 * @Descripttion:
 * @Version: 1.0
 * @Author: 张家彬
 * @Date: 2024-04-08 11:11:09
 * @LastEditors: 张家彬
 * @LastEditTime: 2024-05-06 16:37:03
 */
// 全局共享数据示例
import { DEFAULT_NAME } from '@/constants';
import { storeKeyCurrentUser } from '@/utils/enum';
import { useState } from 'react';

interface ChainInfo {
  id: string;
  status: number;
  name: string;
  algType: string;
}
const useUser = () => {
  const [userInfo, setUserInfo] = useState(() => {
    return JSON.parse(localStorage.getItem(storeKeyCurrentUser) || null) || {};
  });
  const [name, setName] = useState<string>(DEFAULT_NAME);
  const [changePwd, setChangePwd] = useState(true);
  //授权信息
  const [authInfo, setAuthInfo] = useState('');
  //链信息
  const [chainInfo, setChainInfo] = useState<ChainInfo | null>(null);
  return {
    name,
    setName,
    changePwd,
    setChangePwd,
    userInfo,
    setUserInfo,
    authInfo,
    setAuthInfo,
    chainInfo,
    setChainInfo,
  };
};

export default useUser;
